import { ApiProperty } from "@nestjs/swagger";

export class ItemAttributeDto{
@ApiProperty()
id: number;

@ApiProperty()
attribute : string

@ApiProperty()
style : string

@ApiProperty()
attributeValue : string

@ApiProperty()
itemId : number

@ApiProperty()
imCode : string
}